import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { menu } from 'src/app/enums/menu.enum';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  visible : boolean = false;
  listMenu: any[] = [];
  pageCurrent: string = "";
  rol: number = 0;
  user: any;

  constructor(
    private router: Router,
    private storeservice: StoreService
  ) {
  }

  ngOnInit() {  
    this.rol = +this.storeservice.getProfile.rol_id;
    this.user = this.storeservice.getProfile;
    //TODO: llamar servicio menu de backend
    let menuTemp = this.storeservice.optionsListMenu;
    this.listMenu = menuTemp;
    this.getName();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.getName();
    });
  }

  getName(){
    let find = this.listMenu.find((element)=> element.url.includes(this.router.url.replace('/','').split('?')[0]));
    if (find) {
      this.pageCurrent = find.name;
    }
  }


  routerActivate(url:string){
    return this.router.url.includes(url) ? true:false
  }

}
